export enum AccountType {
  Unknown = '',
  /** Bank Account */
  BankAccount = 'BankAccount',
  /** Plooto Instant */
  PrefundedWallet = 'PrefundedWallet',
  /** Credit/Debit Card */
  CreditCardAccount = 'CreditCardAccount',
}
